<template>
  <div class="member-record-wrap">
    <div class="base">
      <Header :name="name"  />
      <div class="list">
        <div class="flex-vertically-center-right">
          <div class="flex-vertically-center  date-selection" @click="handleDateSelection">
            <div class="time">{{ selectedTime }}</div>
            <img class="sx" src="../../assets/images/winterGame/sx.png" alt="">
          </div>
        </div>
        <div class="date-picker">
          <van-popup v-model="showPicker" position="bottom">
            <van-datetime-picker v-model="currentDate" type="date" :columns-order="['year', 'month', 'day']"
              :min-date="minDate" :max-date="maxDate" :formatter="formatter" @cancel="showPicker = false"
              @confirm="confirmPicker" />
          </van-popup>
          <studentTable :dataList="dataList" :total="totalObj" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import Header from '../../components/SquirrelCupII/battalionHeader'
import { agentMyTeamMembers, agreeChangePhone } from "../../api/winterGame";
import { GetRequest } from "@/util/util"
import studentTable from '../../components/SquirrelCupII/student-data.vue'

export default {
  name: 'member-record',
  components: {
    Header,
    studentTable
  },
  data() {
    return {
      name: '战队成员战绩',
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2050, 10, 1),
      currentDate: new Date(),
      dataPickerValue: '',
      selectedTime: '',
      dateTime: '',
      showPicker: false,
      totalObj: {},
      dataList: {
        team_members: []
      }
    }
  },
  async created() {
    this.userInfoId = JSON.parse(localStorage.getItem('userInfoId')) || {}
    await this.FunGetYesDate()
    await this.initData()
  },
  methods: {
    initData() {
      let { agentId, openId } = this.userInfoId || {}
      let params = {
        param: { agentId, openId, date: this.dateTime }
      }
      agentMyTeamMembers(params).then(res => {
        if (res.code === 0) {
          this.dataList['team_members'] = res.data.team_members || []
          this.totalObj = res.data.total || {}
        }
      })
    },
    FunGetYesDate() {
      var myDate, myDateStr;
      // new Date() - 1000 * 60 * 60 * 24
      myDate = new Date();
      var yyyy = myDate.getFullYear();//取四位年份      
      var MM = myDate.getMonth() + 1;//取月份
      var dd = myDate.getDate();//取日
      myDateStr = MM + "月" + dd + '日';
      console.log(myDateStr);
      this.selectedTime = myDateStr;
      this.dateTime = yyyy +"-"+ (MM > 9 ? MM : '0' + MM) + "-" + (dd > 9 ? dd : '0' + dd) 
      return myDateStr
    },
    onConfirm(time) {
      this.dataPickerValue = time;
      this.showPicker = false;
    },
    confirmPicker(time) {
      let year = time.getFullYear();
      let month = time.getMonth() + 1;
      let day = time.getDate();
      let selectedTime = /*year + '-' +*/ month + '月' + day + '日'
      console.log(selectedTime)
      this.dateTime = year +'-'+  (month > 9 ? month : '0' + month) + '-' + (day > 9 ? day : '0' + day) 
      this.selectedTime = selectedTime
      this.showPicker = false;
      this.initData()
    },
    handleDateSelection() {
      this.showPicker = true
    },
    formatter(type, value) {
      if (type === 'year') {
        return value + '年'
      } else if (type === 'month') {
        return value + '月'
      } else if (type === 'day') {
        return value + '日'
      }
      return value
    }
  },
}
</script>

<style lang="less">
@import "../../assets/style/global.less";

.date-picker {
  .van-popup {
    border-top-left-radius: 32px;
    border-top-right-radius: 32px;

    .van-datetime-picker {

      .van-picker__cancel,
      .van-picker__confirm {
        font-size: 32px;
        font-weight: 500;
        color: #58ABF6;
      }

      .van-picker__columns {
        .van-picker-column {
          position: relative;
          z-index: 3;
        }
      }

      .van-hairline-unset--top-bottom.van-picker__frame {
        color: #ffffff;
        background: #D8EFFD;
        z-index: 0;
        left: 0;
        right: 0;
      }
    }
  }
}

.member-record-wrap {
  width: 100%;
  height: 100vh;
  background: url("../../assets/images/winter/second/banner.png") no-repeat top center, linear-gradient(180deg, #002455 0%, #001D46 100%);
  background-size: 100%;

  .btn {
    width: 316px;
    margin: 0 auto;

    span {
      display: inline-block;
      width: 100%;
      background: linear-gradient(90deg, #0374CA 0%, #0091FF 52%, #0374CA 100%);
      border: 1px solid #82C9FF;
      margin: 270px auto 0;
      font-size: 36px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #FFFFFF;
      height: 66px;
      line-height: 66px;
      text-align: center;
    }
  }

  .list {
    position: relative;
    width: 686px;
    // max-height: 600px;
    margin: 0 auto ;
    background: #FFFFFF;
    border-radius: 8px;

    .date-selection {
      position: relative;
      top: 32px;
      margin-right: 32px;
      height: 48px;
      padding: 6px 24px;
      border-radius: 6px;
      border: 2px solid #58ABF6;

      .time {
        font-size: 24px;
        font-weight: 600;
        color: #58ABF6;
      }

      .sx {
        display: block;
        width: 14px;
        height: 22px;
        margin-left: 4px;
      }
    }

  }
}
</style>